const Split = () => {
  return (
    <>
      <div className="border-l border-gray-300 h-4.5 mx-1.5"></div>
    </>
  );
};

export default Split;
